<template>
    <BaseModal
        v-model="show"
        :title="$t('auth.privacyNoticeModalTitle')"
        :dismiss-button="false"
        :initial-focus="acknowledgeButton"
        size="md">
        <p class="text-sm text-gray-600 dark:text-gray-300">
            {{ $t('auth.privacyNoticeModalText') }}
        </p>
        <a
            href="/datenverarbeitung"
            target="_blank"
            class="mt-4 inline-block text-sm font-semibold text-primary-600 hover:text-primary-700 underline">
            {{ $t('auth.privacyNoticeLink') }}
        </a>
        <BaseButton
            ref="acknowledgeButton"
            class="mt-6 w-full"
            color="primary"
            :disabled="loading"
            @click="acknowledge">
            {{ $t('auth.privacyNoticeModalButton') }}
        </BaseButton>
    </BaseModal>
</template>

<script setup>
import {useAuthStore} from '@/store/auth'

const authStore = useAuthStore()
const route = useRoute()
const notification = useNotification()
const {$apiRoute} = useNuxtApp()

const loading = ref(false)
const closed = ref(false)
const acknowledgeButton = ref(null)

// closing without confirming hides it until the next page load
const show = computed({
    get: () => !closed.value
        && authStore.isAuthenticated === true
        && !authStore.impersonate
        && route.name !== 'datenverarbeitung'
        && !!authStore.userData?.id
        && !authStore.userData?.privacy_notice_acknowledged_at,
    set: (value) => {
        if (!value) closed.value = true
    }
})

async function acknowledge() {
    loading.value = true

    await $lara.put($apiRoute('spa.privacyNotice.acknowledge')).then(async () => {
        closed.value = true
        await authStore.getAuthData()
    }).catch(error => {
        notification.error(error?.response?._data?.message)
    })

    loading.value = false
}
</script>
